export class FABHelperResponsive {

    /** Responsive Check */
    static check(e){
        let { mobile, tablet, desktop } = e.responsive.device;
        let display = false;
        display = (window.innerWidth <= 640 && mobile) ? true : display;
        display = (window.innerWidth > 640 && window.innerWidth <= 1024 && tablet) ? true : display;
        display = (window.innerWidth > 1024 && desktop) ? true : display;
        return display;
    }

}